var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.84375C0 0.37776 0.37776 0 0.84375 0H2.66024C3.07269 0 3.4247 0.298192 3.49251 0.705038L4.1163 4.44781C4.1772 4.81318 3.99267 5.17554 3.66137 5.34119L2.35513 5.99431C3.297 8.33483 5.16517 10.203 7.50569 11.1449L8.15881 9.83863C8.32446 9.50733 8.68682 9.3228 9.05219 9.3837L12.795 10.0075C13.2018 10.0753 13.5 10.4273 13.5 10.8398V12.6562C13.5 13.1222 13.1222 13.5 12.6562 13.5H10.9688C4.91088 13.5 0 8.58912 0 2.53125V0.84375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.53e6e0b86f829b892f479855ba96d53d.svg";
export { ForwardRef as ReactComponent };